module.exports = __webpack_public_path__ + "static/media/seta_direita.d69114a0.svg";